export default {
  yyyy: function () {
    var date = new Date();

    return date.getFullYear();
	},
	yyyymmdd: function () {
    var date = new Date();
		var mm = date.getMonth() + 1; // getMonth() is zero-based
    var dd = date.getDate();

    return [date.getFullYear(),
            (mm>9 ? '' : '0') + mm,
            (dd>9 ? '' : '0') + dd
          ].join('');
	},
  yyyyMMddhh: function() {
    var date = new Date();
		var mm = date.getMonth() + 1; // getMonth() is zero-based
    var dd = date.getDate();
    var hour = date.getHours();
        
    return [date.getFullYear(),
            (mm>9 ? '' : '0') + mm,
            (dd>9 ? '' : '0') + dd,
            (hour>9 ? '' : '0') + hour
          ].join('');
  },
  yyyyMMddhhmmss: function() {
    var date = new Date();
		var mm = date.getMonth() + 1; // getMonth() is zero-based
    var dd = date.getDate();

    var hour = date.getHours();
    var minites = date.getMinutes();
    var seconds = date.getSeconds();
        
    return [date.getFullYear(),
            (mm>9 ? '' : '0') + mm,
            (dd>9 ? '' : '0') + dd,
            (hour>9 ? '' : '0') + hour,
            (minites>9 ? '' : '0') + minites,
            (seconds>9 ? '' : '0') + seconds
          ].join('');
  }
}
